var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"value":_vm.count > 0,"content":_vm.count,"color":"primary","bordered":"","overlap":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"elevation":"0"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-filter ")]),_vm._v(" "+_vm._s(_vm.$t("label.button.filters"))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }